import {
  Box,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from '@mui/material';
import { useTheme } from '@emotion/react';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import SecurityOutlinedIcon from '@mui/icons-material/SecurityOutlined';
import { tokens } from '../../../../theme';
import { Button } from '../../../../components/Button';
import { useTranslation } from '../../../../hooks/useTranslation';

const selectSx = {
  backgroundColor: '#fff',
  fontSize: '13px',
  '& .MuiOutlinedInput-notchedOutline': { borderColor: '#e0e0e0' },
};

const Step3Garantias = ({ formData, updateFormData, onNext, onBack, options }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const { t } = useTranslation();

  const s = 'createContractModal.step3';

  const garantias = formData.garantias ?? [{ id: Date.now(), value: '' }];

  const handleChange = (index, value) => {
    const updated = garantias.map((g, i) => (i === index ? { ...g, value } : g));
    updateFormData({ garantias: updated });
  };

  const handleAdd = () => {
    updateFormData({ garantias: [...garantias, { id: Date.now(), value: '' }] });
  };

  const handleRemove = (index) => {
    const updated = garantias.filter((_, i) => i !== index);
    updateFormData({ garantias: updated.length ? updated : [{ id: Date.now(), value: '' }] });
  };

  return (
    <Box>
      <Box sx={{ border: '1px solid #e0e0e0', borderRadius: 2, p: 2.5, mb: 3 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
          <Box sx={{ color: colors.greenAccent[500] }}>
            <SecurityOutlinedIcon fontSize="small" />
          </Box>
          <Typography sx={{ fontWeight: 700, fontSize: '14px' }}>
            {t(`${s}.guaranteeSection`)}{' '}
            <Box component="span" sx={{ fontStyle: 'italic', fontWeight: 400, color: '#9e9e9e' }}>
              {t(`${s}.optional`)}
            </Box>
          </Typography>
        </Box>

        <Typography sx={{ fontSize: '12px', color: '#9e9e9e', mb: 2 }}>
          {t(`${s}.addGuaranteeHint`)}
        </Typography>

        {garantias.map((g, index) => (
          <Box key={g.id} sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5 }}>
            <FormControl fullWidth size="small">
              <InputLabel sx={{ fontSize: '13px' }}>{t(`${s}.selectGuarantee`)}</InputLabel>
              <Select
                value={g.value}
                label={t(`${s}.selectGuarantee`)}
                onChange={(e) => handleChange(index, e.target.value)}
                sx={selectSx}
              >
                {(options?.garantias ?? []).map((gk) => (
                  <MenuItem key={gk.id} value={gk.id} sx={{ fontSize: '13px' }}>{gk.name}</MenuItem>
                ))}
              </Select>
            </FormControl>
            {garantias.length > 1 && (
              <IconButton size="small" onClick={() => handleRemove(index)} sx={{ color: '#ef5350', flexShrink: 0 }}>
                <DeleteOutlineIcon fontSize="small" />
              </IconButton>
            )}
          </Box>
        ))}

        <Typography
          sx={{
            fontSize: '13px',
            color: colors.greenAccent[500],
            fontWeight: 600,
            cursor: 'pointer',
            mt: 1,
            display: 'inline-flex',
            alignItems: 'center',
            gap: 0.5,
            '&:hover': { textDecoration: 'underline' },
          }}
          onClick={handleAdd}
        >
          {t(`${s}.addGuaranteeLink`)}
        </Typography>
      </Box>

      <Box sx={{ display: 'flex', justifyContent: 'space-between', pt: 1 }}>
        <Button variant="outlined" fullWidth={false} onClick={onBack} sx={{ minWidth: 120 }}>
          {t(`${s}.backButton`)}
        </Button>
        <Button variant="contained" fullWidth={false} onClick={onNext} sx={{ minWidth: 120 }}>
          {t(`${s}.nextButton`)}
        </Button>
      </Box>
    </Box>
  );
};

export default Step3Garantias;
